export const fetchCCAIUserToken =
  (
    apiUrl: string,
    {
      name,
      email,
      phone
    }: {
      name: string;
      email?: string;
      phone?: string;
    }
  ): (() => Promise<{ token: string }>) =>
    async () => {
      const formData = new FormData();
      formData.append('name', name);
      if (email) formData.append('email', email);
      if (phone) formData.append('phone', phone);

      const resp = await fetch(`${apiUrl}/jwt`, {
        method: 'POST',
        body: formData
      });

      const token = await resp.text();

      return { token };
    };
